"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var Antd = __importStar(require("antd"));
// Styled version of statics
var StyledGroup = styled_components_1.default(Antd.Radio.Group)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .ant-radio-wrapper,\n    .ant-radio-button-wrapper {\n        display: ", ";\n    }\n    .ant-radio-button-wrapper {\n        padding: ", ";\n    }\n"], ["\n    .ant-radio-wrapper,\n    .ant-radio-button-wrapper {\n        display: ", ";\n    }\n    .ant-radio-button-wrapper {\n        padding: ", ";\n    }\n"])), function (_a) {
    var vertical = _a.vertical;
    return (vertical ? 'block' : 'inline-block');
}, function (_a) {
    var theme = _a.theme;
    return "0 " + theme.spacing.md;
});
var StyledButton = styled_components_1.default(Antd.Radio.Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
// Our exported styled component version of Antd will need to have a reference to the styled
// component version.
var VarnishRadio = /** @class */ (function (_super) {
    __extends(VarnishRadio, _super);
    function VarnishRadio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VarnishRadio.Group = StyledGroup;
    VarnishRadio.Button = StyledButton;
    return VarnishRadio;
}(Antd.Radio));
// Styled version.
var StyledRadio = styled_components_1.default(VarnishRadio)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n"], ["\n    font-size: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmall.fontSize;
});
// We trick Typescript here by first casting to unknown and then casting to the type we'd like to export.
// We do this so that the exported type includes the static properties, which we lose otherwise.
exports.Radio = StyledRadio;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Radio.js.map